import { useFormik } from "formik";
import { Fragment, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from 'yup';
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import axios from "axios";
import { UserContext } from "../../Context/UserContext.js";
import { CartContext } from "../../Context/CartContext.js";
import Swal from 'sweetalert2';
import { logOut } from "../../Utilities/logOut.js";
import style from "./login.module.css";
import imageBtn from "../../Assets/images/347393388_770410248209055_564858472947380600_n.png";
import CustomTitle from "../CustomTitle/CustomTitle.jsx";

export default function Login() {

   let navigate = useNavigate()
   const [error, setError] = useState(null)
   const [loading, setLoading] = useState(false)
   const [loadingGoogle, setLoadingGoogle] = useState(false)
   const { setRole, setLoggedUser, setUserToken, setAdmin, setModerator } = useContext(UserContext)
   const totalUserInfo = useContext(UserContext);

   const { getLoggedCart, getOrderCount } = useContext(CartContext);
   const [showPassword, setShowPassword] = useState(false);





   //& Handle Phone Empty Or Email Empty :
   async function submitLogin(values) {
      const token_expiration = Number(process.env.REACT_APP_TOKEN_EXPIRATION) || 7210000;

      // console.log("ENV:", process.env);


      setLoading(true);

      let { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/signIn`, values)
         .catch((error) => {
            setError(error.response.data.message)
            toast.error(error.response.data.message)
            setLoading(false)
         })

      //^ Check Login Success User :
      if (data?.message === "success") {

         setLoading(false)
         //& save Token In Local Storage And Save Token in Use Context :
         localStorage.setItem("token", data.token);
         setUserToken(data.token);

         const token = data.token;
         let decoded = jwtDecode(token);
         setLoggedUser(decoded);


         //& Get Item In Logged User Cart : 
         getLoggedCart();
         getOrderCount()


         //& Set Role :
         setRole(decoded.role);


         //& Check Admin Or Or Moderator Or User :
         if (decoded.role === "admin") {
            setAdmin(true)
         } else if (decoded.role === "moderator") {
            setModerator(true)
         }

         if (decoded.role === "user") {
            navigate("/home");
         } else if (decoded.role === "admin" || decoded.role === "moderator") {
            navigate("/dashboard");
         }
         setTimeout(() => {
            handleLogOut()
         }, (token_expiration));
         // After 1 hours   logout
         // 60*10*1000 = 600,000= 10 minute
         // 60*20*2*1000 = 2400,000= 1/3 hours
         // 60*60*1000 = 3600,000= 1 hours  
         // 60*60*2*1000 = 7200,000= 2 hours  
      } else {
         navigate("/");
      }
   }



   //& Handle Log Out :
   function handleLogOut() {
      logOut(navigate, totalUserInfo);
      Swal.fire({
         title: "Session Expired !",
         text: "Session Expired .Please Try Log in Again !!",
         icon: "error"
      });
   }






   let validationSchema = Yup.object({
      userAccount: Yup.string().required().trim(),
      password: Yup.string().required().matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]?).{7,}$/, "should be Password Start UpperCase And Contain 8 Character And Contain any (@#$%&*)"),
   })


   let formik = useFormik({
      initialValues: {
         userAccount: "",
         password: "",
      }, validationSchema,
      onSubmit: submitLogin
   })


   const handleClick = () => {
      setLoadingGoogle(true)
   }

   return (
      <Fragment>
         <CustomTitle title="تسجيل الدخول" />

         <div className={`container-fluid ${style.login_container}`}>
            <div className="row">
               <div className="col-lg-6 p-0">
                  <div className={`${style.logoImage}`}></div>
               </div>

               <div className="col-lg-6 p-0">
                  <div className=" w-100 p-3">
                     <h1 className="main-header">تسجيل الدخول</h1>

                     <p className="sub-title text-center">برجاء إدخال الايميل او رقم التليفون وكلمة المرور  </p>

                     <form action="" onSubmit={formik.handleSubmit}>

                        {error ? <p className="text-danger">{error}</p> : ""}

                        <div className="my-4 position-relative">
                           <i className="fas fa-user icon-input-field"></i>
                           <label htmlFor="userAccount" className="form-label required">يرجى إدخال البريد الالكترونى او رقم التليفون</label>
                           <input type="text"
                              value={formik.values.userAccount}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="form-control " id="userAccount"
                              name="userAccount"
                              required
                              autoComplete="username"
                              placeholder="البريد الالكترونى او رقم التليفون" />
                           {
                              formik.errors.userAccount && formik.touched.userAccount ?
                                 <div className="text-danger m-0 p-0">{formik.errors.userAccount}</div>
                                 :
                                 <p className="text-new m-0 p-0">يرجى إدخال البيانات الصحيحة</p>
                           }
                        </div>

                        <div className="my-4 position-relative">
                           <i className="fas fa-lock icon-input-field"></i>
                           <label htmlFor="password" className="form-label required">إدخال كلمة المرور للمستخدم </label>
                           <input type={showPassword ? "text" : "password"}
                              value={formik.values.password}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="form-control" id="password"
                              name="password"
                              required
                              autoComplete="current-password"
                              placeholder=" كلمة المرور "

                              /** ==== Prevent Copy , Cut , paste , Right Click ==== */
                              onCopy={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                              onCut={(e) => e.preventDefault()}
                              onContextMenu={(e) => e.preventDefault()}
                           />
                           {
                              formik.errors.password && formik.touched.password ?
                                 <p className="text-danger m-0 p-0">{formik.errors.password}</p>
                                 :
                                 <p className="text-new m-0 p-0">يرجى إدخال البيانات الصحيحة</p>
                           }

                           {showPassword ? (
                              <i className="fas fa-eye toggle-password" onClick={() => setShowPassword(false)}></i>
                           ) : (
                              <i className="fas fa-eye-slash toggle-password" onClick={() => setShowPassword(true)}></i>
                           )}
                        </div>

                        <div className="d-grid gap-2 col-8 mx-auto">
                           {loading ?
                              <button className="btn bg-main text-white  mt-2"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                              :
                              <button disabled={!(formik.isValid && formik.dirty)} type="submit" className="btn bg-main  mt-2">تسجيل الدخول</button>
                           }
                           <div className="row">
                              <div className="col-md-6">
                                 <p className={`${style.register_text} text-center mt-1`}>Create your account?<Link className="m-1 main-color" to="/register" >إنشاء حساب </Link></p>
                              </div>
                              <div className="col-md-6">
                                 <p className={`${style.register_text} text-center mt-1`}><Link className="m-1 main-color" to="/ForgetPassword" ><i className="fa-solid fa-lock me-2"></i> نسيت كلمة المرور  ؟ </Link></p>
                              </div>
                           </div>
                        </div>

                     </form>

                     <div className="position-relative">
                        <hr />
                        <span className={`${style.separator}`}>OR</span>
                     </div>

                     <div className="row">
                        <div className="col-md-6 offset-md-3">
                           <div className="">
                              <a href={`${process.env.REACT_APP_BASE_URL}/auth/google`}>
                                 {loadingGoogle ?
                                    <button className="btn bg-main w-100"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                                    :
                                    // <button onClick={()=>{handleClick()}} className="btn btn-outline-success w-100">Login With Google  <i class="fa-brands fa-google ms-4"></i></button>
                                    <button onClick={() => { handleClick() }} className={`${style.btnLoginGoogle}`}>Login With Google  <img src={imageBtn} alt="" srcset="" /></button>
                                 }
                              </a>
                              {/* <button className={`${style.btnLoginGoogle} my-3`}>اتصفح عروضنا الجديدة</button> */}
                           </div>
                        </div>
                     </div>

                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   )
} 